/* Cart drawer helpers (countdown + theme editor).
   Runs once per page even if the drawer is re-rendered many times. */
(function () {
  if (window.__eeCartDrawerInit) return;
  window.__eeCartDrawerInit = true;

  var KEY = 'ee-cart-timer-end';

  function store(get, value) {
    try {
      if (get) return sessionStorage.getItem(KEY);
      sessionStorage.setItem(KEY, value);
    } catch (e) {
      if (get) return window.__eeTimerEnd || null;
      window.__eeTimerEnd = value;
    }
    return null;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tick() {
    var timers = document.querySelectorAll('[data-ee-timer]');
    if (!timers.length) return;
    var timer = timers[0];
    var duration = parseInt(timer.getAttribute('data-duration'), 10) || 540;
    var mode = timer.getAttribute('data-on-expire') || 'restart';
    var now = Date.now();
    var end = parseInt(store(true), 10);

    if (!end || end - now > duration * 1000) {
      end = now + duration * 1000;
      store(false, String(end));
    }
    var left = Math.round((end - now) / 1000);
    if (left <= 0) {
      if (mode === 'restart') {
        end = now + duration * 1000;
        store(false, String(end));
        left = duration;
      } else {
        left = 0;
      }
    }
    var label = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    timers.forEach(function (t) {
      t.hidden = mode === 'hide' && left === 0;
      t.querySelectorAll('[data-ee-timer-value]').forEach(function (v) {
        if (v.textContent !== label) v.textContent = label;
      });
    });
  }

  setInterval(tick, 1000);
  tick();

  /* Re-run instantly when the drawer HTML is replaced (quantity change, add to cart),
     so the timer never flashes back to its start value. */
  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__eeObserved) return;
    drawer.__eeObserved = true;
    new MutationObserver(function () {
      tick();
    }).observe(drawer, { childList: true, subtree: true });
  }
  observe();
  document.addEventListener('DOMContentLoaded', observe);

  /* Theme editor: open the drawer when its section or a block is selected */
  if (window.Shopify && Shopify.designMode) {
    var isCart = function (e) {
      return e.target && e.target.querySelector && e.target.querySelector('cart-drawer');
    };
    document.addEventListener('shopify:section:select', function (e) {
      var d = isCart(e);
      if (d && typeof d.open === 'function') d.open();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.shopify-section');
      var d = section && section.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var d = isCart(e);
      if (d && typeof d.close === 'function') d.close();
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (isCart(e)) {
        observe();
        tick();
      }
    });
  }
})();
